export const findDenominationByServiceId = <T extends { serviceId: string }>(
  denominations: Record<string, T[]>,
  serviceId: string | undefined
): T | null => {
  if (!serviceId) {
    return null
  }

  return (
    Object.values(denominations)
      .flat()
      .find((payee) => payee.serviceId === serviceId) || null
  )
}
